import React from 'react';
import { connect } from 'react-redux';
import { Section, Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import ItemForm from '../Form';
import { createItem } from '@resources/Item/actions';
import { useIntl } from 'react-intl';

const Create = (props) => {
	const { module, createItem, visible, onCancel } = props;
	const intl = useIntl();

	const handleSubmit = (data) => {
		return createItem(data)
			.then((response) => {
				popIn(
					'success',
					intl.formatMessage({
						id: 'message.success.item.create',
						defaultMessage:
							'A new Item has been successfully created',
					})
				);

				onCancel && onCancel();
			})
			.catch((err) => Promise.reject(err));
	};

	return (
		<Modal visible={visible} onCancel={() => onCancel && onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.new.item',
					defaultMessage: 'Create Item',
				})}
			</Title>
			<Section className="mb-5">
				<ItemForm onSubmit={handleSubmit} {...props} module={module} />
			</Section>
		</Modal>
	);
};

const mapStateToProps = ({
	items,
	modules,
	cellGroup,
	event,
	facility,
	ministry,
	mission,
	organization,
	prayer,
	testimony,
	service,
}) => {
	return {
		items,
		modules,
		cellGroup,
		event,
		facility,
		ministry,
		mission,
		organization,
		prayer,
		testimony,
		service,
	};
};

export default connect(mapStateToProps, {
	createItem,
})(Create);
